import { BodyText } from '@unmind/design-system';
import styled from 'styled-components';

export const AboutModalTitleContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.sheet.background};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: 20px 20px 0 20px;
`;

export const AboutModalTitleText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize18],
  weight: theme.typography.fontWeights.semiBold,
}))``;

export const AboutModalContentContainer = styled.div`
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.sheet.background};
`;

export const AboutModalBodyText = styled(BodyText).attrs(({ theme }) => ({
  color: theme.colors.text.primary,
  sizes: [theme.typography.fontSizes.fontSize14],
}))``;
